import EditorCheckListCard from "./EditorCheckListCard";
import EditorSectionHeader from "../common/EditorSectionHeader";

// TrailerCheckList: the variant's checklist card for the trailer
const EditorChecklistSection = (props) => {
  const {
    TrailerCheckList,
    listProblemData,
    isBerangkat,
    showBerangkat,
    setShowBerangkat,
  } = props;

  // props shared by every checklist card
  const common = props;

  const cardClassName = "elevated-card grow row-start-start !py-4 !px-4";

  return (
    <>
      {/* problem history section */}
      {/* <div className="elevated-card-tight-vertical !px-4 !py-3 !bg-red-200 row-between-center w-full">
        <span className="text-sm font-bold text-slate-700">
          PROBLEM YANG BELUM SELESAI
        </span>
        <Button
          icon="pi pi-refresh"
          loading={loading}
          rounded
          onClick={() => {
            if (headerData && headerData.kendaraan_id > 0)
              fetchProblemMobil({
                kendaraanId: headerData.kendaraan_id,
              });
          }}
        />
      </div>
      <div className="elevated-card grow row-start-start !py-4 !px-4 !bg-red-200 w-full">
        <ProblemTable
          data={listProblemData}
          kendaraan={headerData.data_kendaraan}
          onReload={fetchProblemMobil}
          loading={loading}
        />
      </div> */}
      <EditorSectionHeader
        className="elevated-card-tight-vertical !px-4 !py-3 !bg-indigo-300 row-between-center w-full"
        title="CHECKLIST"
        isBerangkat={isBerangkat}
        showBerangkat={showBerangkat}
        setShowBerangkat={setShowBerangkat}
      />
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check list depan */}
        <EditorCheckListCard
          {...common}
          wrapperClassName={cardClassName}
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === "bagian_depan"
          )}
          title={"Bagian Depan"}
          labelGrup={"bagian_depan"}
        />
        {/* check list samping */}
        <EditorCheckListCard
          {...common}
          wrapperClassName={cardClassName}
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === "bagian_samping"
          )}
          title={"Bagian Samping"}
          labelGrup={"bagian_samping"}
        />
      </div>
      <div className="row-start-start w-full flex-wrap gap-4">
        {/* check list belakang */}
        <EditorCheckListCard
          {...common}
          wrapperClassName={cardClassName}
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === "bagian_belakang"
          )}
          title={"Bagian Belakang"}
          labelGrup={"bagian_belakang"}
        />
        {/* check list dalam */}
        <EditorCheckListCard
          {...common}
          wrapperClassName={cardClassName}
          listProblemData={listProblemData.filter(
            (el) => el.label_grup === "bagian_dalam"
          )}
          title={"Bagian Dalam"}
          labelGrup={"bagian_dalam"}
        />
      </div>
      <TrailerCheckList {...common} />
    </>
  );
};

export default EditorChecklistSection;
